import { render, staticRenderFns } from "./jotFormIframe.vue?vue&type=template&id=558eda7e&scoped=true&"
import script from "./jotFormIframe.vue?vue&type=script&lang=js&"
export * from "./jotFormIframe.vue?vue&type=script&lang=js&"
import style0 from "./jotFormIframe.vue?vue&type=style&index=0&id=558eda7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558eda7e",
  null
  
)

export default component.exports